export default __webpack_public_path__ + "static/media/refer.25a1bb9d.svg";